import type { BigNumber } from '@ethersproject/bignumber';
import formatBigNumber from '@utils/format/formatBigNumber';

export default function formatSTC(amount_STC: BigNumber) {
  return formatBigNumber(amount_STC, { divide: 6 });
}
